import script from "./import-settlement-amount.vue?vue&type=script&lang=tsx&setup=true"
export * from "./import-settlement-amount.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__